import { Stack } from '@mui/material';
import ChannelBreakdownDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/channel-breakdown-definitions/channel-breakdown-definitions.component';
import LocationDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/location-definitions/location-definitions.component';
import MembershipDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/membership-definitions/membership-definitions.component';
import SalesAndRevenueDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/sales-and-revenue-definitions/sales-and-revenue-definitions.component';
import OrderDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/order-definitions/order-definitions.component';
import UniqueUserDefinitions from 'pages/loyalty-performance-report/loyalty-performance-api-definitions/unique-user-definitions/unique-user-definitions.component';

const LocationLoyaltyPerformanceApiDefinitions = () => {
  return (
    <Stack spacing={2}>
      <LocationDefinitions />
      <MembershipDefinitions />
      <OrderDefinitions />
      <SalesAndRevenueDefinitions />
      <ChannelBreakdownDefinitions />
      <UniqueUserDefinitions />
    </Stack>
  );
};

export default LocationLoyaltyPerformanceApiDefinitions;
